import script from "./PaymentReceiptForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentReceiptForm.vue?vue&type=script&setup=true&lang=js"

import "./PaymentReceiptForm.vue?vue&type=style&index=0&id=02f851b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02f851b3"]])

export default __exports__